import { axios } from '@Root/API'

export const checkStudents = params => {
  return axios.get(`students/rollover/info-continuing`, { params })
}
